import React, { useEffect, createContext } from 'react';
import { PokerTableStage } from './PokerTableStage';
import { PokerUIOverlay } from './PokerUIOverlay';
import { ThemeProvider } from './theme/ThemeProvider';
import { PokerSocket } from './network/PokerSocket';
import { resumeAudioContext } from './audio/audioManager';
import { Lobby } from './Lobby';
import { useTableStore } from './state/tableStore';

export const SocketContext = createContext<PokerSocket | null>(null);

export const PokerTableApp: React.FC = () => {
  const [socket, setSocket] = React.useState<PokerSocket | null>(null);
  const [wsError, setWsError] = React.useState<string | null>(null);
  const [inLobby, setInLobby] = React.useState(true);
  const [tableId, setTableId] = React.useState<string | null>(null);
  const [buyIn, setBuyIn] = React.useState<number>(1000);
  const [autoSit, setAutoSit] = React.useState(true);
  const { setInitialBuyIn } = useTableStore();
  useEffect(() => {
    const handleGesture = () => {
      resumeAudioContext();
      window.removeEventListener('pointerdown', handleGesture);
      window.removeEventListener('keydown', handleGesture);
    };
    window.addEventListener('pointerdown', handleGesture, { once: true });
    window.addEventListener('keydown', handleGesture, { once: true });
    return () => {
      window.removeEventListener('pointerdown', handleGesture);
      window.removeEventListener('keydown', handleGesture);
    };
  }, []);
  useEffect(() => {
    if (inLobby) return;
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  const host = window.location.host;
  const tableParam = tableId ? `?tableId=${encodeURIComponent(tableId)}` : '';
  const wsUrl = process.env.REACT_APP_POKER_WS_URL || `${protocol}://${host}/ws/poker${tableParam}`;
  const socket = new PokerSocket(wsUrl);
    socket.onOpen = () => {
      setWsError(null);
      socket.send({ type: 'join_table', tableId: tableId ?? undefined, autoSit, buyIn });
    };
    socket.onError = () => {
      setWsError(`Failed to connect to the poker server at ${wsUrl}. Please try again later.`);
    };
    socket.onClose = () => {
      setWsError(`Connection closed. Reconnecting to ${wsUrl}...`);
    };
    socket.connect();
    setSocket(socket);
    return () => {
      socket.close();
      setSocket(null);
    };
  }, [inLobby, tableId, buyIn, autoSit]);
  return (
    <ThemeProvider>
      <SocketContext.Provider value={socket}>
        <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', background: '#0F1A2B' }}>
          {wsError && (
            <div style={{ color: 'white', background: 'red', padding: 16, textAlign: 'center', zIndex: 10000, position: 'absolute', top: 0, width: '100%' }}>
              {wsError}
            </div>
          )}
          {inLobby ? (
            <Lobby
              onStart={(info) => {
                setTableId(info.tableId ?? null);
                if (info.buyIn) setBuyIn(info.buyIn);
                if (info.buyIn) setInitialBuyIn(info.buyIn);
                setAutoSit(info.autoSit ?? true);
                setInLobby(false);
              }}
            />
          ) : (
            <>
              <PokerTableStage />
              <PokerUIOverlay />
            </>
          )}
        </div>
      </SocketContext.Provider>
    </ThemeProvider>
  );
};
